export default "/images/37e9c8be33bdb036c4d6dc756480ab12.avif";